import user_page from './user-page';

export default function (nameAction, namePage) {
    if (nameAction === 'userpage') user_page(namePage);
}